import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiTabMenuComponent } from '@common/ui/frontend-shared/tabmenu';
import { FeatureMenuItemService } from '@core/frontend-shared/feature';
import { RouterLinkResolverService } from '@core/shared/feature';
import { NotificationsInfoIconComponent } from '@common/notifications/frontend-shared';
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared/feature";
import * as i2 from "@core/shared/feature";
import * as i3 from "@angular/common";
import * as i4 from "@common/ui/frontend-shared/shared";
import * as i5 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
function LayoutToolbarComponent_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 3);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", item_r1.icon)("icon", item_r1.icon);
  }
}
function LayoutToolbarComponent_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "notifications-info-icon");
  }
}
function LayoutToolbarComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵconditionalCreate(1, LayoutToolbarComponent_ng_template_2_Conditional_1_Template, 1, 2, "ui-icon", 3);
    i0.ɵɵconditionalCreate(2, LayoutToolbarComponent_ng_template_2_Conditional_2_Template, 1, 0, "notifications-info-icon");
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r1.icon && item_r1.id !== "notifications" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r1.id === "notifications" ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r1.label, " ");
  }
}
export let LayoutToolbarComponent = /*#__PURE__*/(() => {
  class LayoutToolbarComponent {
    constructor(featureMenuItemService, resolver) {
      this.resolver = resolver;
      this.activeItem = 0;
      this.menu$ = featureMenuItemService.getOrderedMenuItems('toolbar', []);
    }
    static {
      this.ɵfac = function LayoutToolbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutToolbarComponent)(i0.ɵɵdirectiveInject(i1.FeatureMenuItemService), i0.ɵɵdirectiveInject(i2.RouterLinkResolverService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutToolbarComponent,
        selectors: [["layout-toolbar"]],
        hostAttrs: ["ngSkipHydration", "true"],
        decls: 3,
        vars: 4,
        consts: [["e2e-bottom-toolbar", "", 3, "model", "activeItem"], ["uiTemplate", "item"], [1, "content"], ["size", "2x", 3, "ngClass", "icon"], [1, "label"]],
        template: function LayoutToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ui-tabMenu", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, LayoutToolbarComponent_ng_template_2_Template, 5, 3, "ng-template", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("model", i0.ɵɵpipeBind1(1, 2, ctx.menu$))("activeItem", ctx.activeItem);
          }
        },
        dependencies: [CommonModule, i3.NgClass, i4.UiTemplateDirective, UiIconsModule, i5.UiIconComponent, UiTabMenuComponent, NotificationsInfoIconComponent, i3.AsyncPipe],
        styles: [".content[_ngcontent-%COMP%]{text-align:center;color:var(--toolbarTextColor);font-size:var(--fontSizeSmall)}.label[_ngcontent-%COMP%]{font-family:inherit;font-size:var(--fontSizeSmall);font-weight:400;letter-spacing:.04rem;margin-top:10px}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu{--tabMenuItemPadding: 8px 2px}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu{background:var(--toolbarMenuBgColor)}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu .p-tabmenu-nav{display:flex;background-color:var(--toolbarMenuBgColor);max-width:710px;margin:0 auto!important}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu .p-tabmenu-nav>li.p-tabmenuitem{flex:1;margin-bottom:0!important}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu .p-tabmenu-nav>li.p-tabmenuitem>a{background-color:var(--toolbarMenuBgColor);display:block;display:flex;align-items:center;justify-content:center;float:none!important;height:var(--bottombarHeight)}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu .p-tabmenu-nav>li.p-tabmenuitem>a>.content{z-index:5;position:relative}[_nghost-%COMP%]     ui-tabMenu .p-tabmenu .p-tabmenu-nav>li.p-tabmenuitem.p-highlight>a{background-color:var(--toolbarMenuitemActiveBgColor);color:var(--toolbarMenuitemActiveColor)}@media (min-width: 960px){[_nghost-%COMP%]     ui-tabMenu .p-tabmenu .p-tabmenu-nav>li.p-tabmenuitem>a .label{margin:7px 0 -5px}}[ui-theme=contrast]   [_nghost-%COMP%]     ui-tabMenu .p-tabmenu{border-top:var(--basicPanelBorder)}"]
      });
    }
  }
  return LayoutToolbarComponent;
})();